import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Loader from "../../components/common/Loader";
import ErrorState from "../../components/common/ErrorState";
import EmptyState from "../../components/common/EmptyState";
import applicationStatusService from "../../services/applicationStatusService";
import { usePanelAuth } from "../../context/PanelAuthContext";
import logo from "../../assets/logo.png";

export default function PanelDashboard() {
  const { panel, logout } = usePanelAuth();
  const [rounds, setRounds] = useState([]);
  const [state, setState] = useState("loading");

  function load() {
    setState("loading");
    applicationStatusService
      .myRounds()
      .then((res) => {
        setRounds(res.data || []);
        setState((res.data || []).length ? "ready" : "empty");
      })
      .catch(() => setState("error"));
  }

  useEffect(load, []);

  return (
    <div className="pm-student-shell">
      <header className="pm-student-topbar">
        <Link to="/" className="pm-auth-brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>
        <div className="pm-student-topbar__right">
          <span>{panel?.name}</span>
          <button className="pm-btn pm-btn--ghost pm-btn--sm" onClick={logout}>Log out</button>
        </div>
      </header>

      <div className="pm-page">
        <header className="pm-page__header">
          <div>
            <span className="pm-eyebrow">Panel</span>
            <h1>Your assigned rounds</h1>
          </div>
        </header>

        {state === "loading" && <Loader label="Loading your rounds" />}
        {state === "error" && <ErrorState onRetry={load} />}
        {state === "empty" && <EmptyState title="No rounds assigned yet" description="Check back once an admin tags you to a round." />}

        {state === "ready" && (
          <div className="pm-campus-manage-grid">
            {rounds.map((r, i) => (
              <motion.div
                key={r.id}
                className="pm-manage-card"
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: Math.min(i, 6) * 0.05 }}
              >
                <div className="pm-manage-card__top">
                  <span className="pm-manage-card__count">{r.pending_count} pending review</span>
                </div>
                <h3>{r.round_name}</h3>
                <p>{r.university_name}</p>
                <Link to={`/panel/rounds/${r.id}`} className="pm-btn pm-btn--primary pm-btn--sm" style={{ marginTop: 10 }}>
                  Review candidates →
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}